export default {
    alerts: {
        active: 'فعال',
        edit: 'ویرایش اطلاعیه',
        inactive: 'Inactive',
        menu: {
            create: 'ایجاد',
            index: 'اطلاعیه‌ها',
            list: 'اطلاعیه‌ها'
        },
        table_titles: {
            bg_color: 'رنگ پس‌زمینه',
            created_at: 'تاریخ ایجاد',
            display_on_landing: 'نمایش در صفحه‌ی ورودی',
            display_on_login: 'نمایش در صفحه‌ی لاگین',
            display_on_home: 'نمایش در صفحه‌ی اصلی',
            expired_at: 'تاریخ انقضاء',
            id: 'ID',
            priority: 'اولویت',
            published_at: 'زمان انتشار',
            setting: 'ویرایش | حذف',
            state: 'وضعیت',
            title: 'عنوان'
        },
        title_hint: 'این عنوان تنها برای مدیریت اطلاعیه‌ها استفاده می‌شود',
        yes: 'بله',
        no: 'خیر'
    }
}
